export default __webpack_public_path__ + "static/media/inclusive.4817d71a.svg";